import React from "react";
import "./HowWeHelp.scss";

const HowWeHelp = ({ helpItems }) => {
  return (
    <section className="how-we-help">
      <div className="help-container">
        <span className="subtitle">How We Help?</span>
        <h2 className="main-header">
          Driving Business Through Strategy and Execution
        </h2>

        <div className="help-grid">
          {helpItems &&
            helpItems.map((item, index) => (
              <div
                key={index}
                className={`help-item ${
                  index % 2 === 0 ? "blue-border" : "orange-border"
                }`}
              >
                <div className="icon-wrapper">
                  {item.icon ? (
                    <img src={item.icon} alt={`icon-${index}`} />
                  ) : (
                    <div className="icon-placeholder"></div>
                  )}
                </div>
                <p className="help-text">{item.description}</p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
